var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 12.8333C3.77834 12.8333 1.16666 10.2216 1.16666 6.99999C1.16666 3.77833 3.77834 1.16666 7 1.16666C10.2216 1.16666 12.8333 3.77833 12.8333 6.99999C12.8333 10.2216 10.2216 12.8333 7 12.8333ZM7 11.6667C9.57734 11.6667 11.6667 9.57733 11.6667 6.99999C11.6667 4.42266 9.57734 2.33332 7 2.33332C4.42267 2.33332 2.33333 4.42266 2.33333 6.99999C2.33333 9.57733 4.42267 11.6667 7 11.6667ZM6.41666 4.08332H7.58333V5.24999H6.41666V4.08332ZM6.41666 6.41666H7.58333V9.91666H6.41666V6.41666Z",
    fill: "#888",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIIcon);
export default __webpack_public_path__ + "static/media/i-icon.479bc1ec206448f4a619fd0bd52a39c7.svg";
export { ForwardRef as ReactComponent };